import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Pagination extends Component {
    render() {
        return (
            <div className="pagination-wrap">
                <ul>
                    <li><Link to="/blog-detail"><i className="far fa-angle-double-left" /></Link></li>
                    <li className="active"><Link to="/blog-detail">1</Link></li>
                    <li><Link to="/blog-detail">2</Link></li>
                    <li><Link to="/blog-detail">3</Link></li>
                    <li><Link to="/blog-detail">...</Link></li>
                    <li><Link to="/blog-detail">10</Link></li>
                    <li><Link to="/blog-detail"><i className="far fa-angle-double-right" /></Link></li>
                </ul>
            </div>
        );
    }
}

export default Pagination;